import { CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { DashboardRoute } from '../util/url';

const TOTAL_SECONDS = 60;

function formatCountdown(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

function redirectToDashboard(): void {
  const url = `${window.location.origin}${DashboardRoute}`;
  const top = window.top;
  if (top !== null && window.self !== top) {
    top.location.href = url;
  } else {
    window.location.href = url;
  }
}

export function RestartRmfPage(): React.ReactElement {
  const [secondsLeft, setSecondsLeft] = React.useState(TOTAL_SECONDS);

  React.useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          redirectToDashboard();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const progressValue = ((TOTAL_SECONDS - secondsLeft) / TOTAL_SECONDS) * 100;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1976d2',
        color: 'white',
        padding: 24,
      }}
    >
      <div
        style={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress
          variant="determinate"
          value={progressValue}
          size={240}
          thickness={4}
          sx={{
            color: 'white',
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            },
          }}
        />
        <div
          style={{
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h3" component="span" fontWeight="bold">
            {formatCountdown(secondsLeft)}
          </Typography>
        </div>
      </div>
      <Typography variant="h6" sx={{ mt: 3, textAlign: 'center', maxWidth: 360 }}>
        The RMF system is being restarted, please wait.
      </Typography>
    </div>
  );
}
